angular
  .module('app')
  .service('colorBlog', ['httpService', 'appConfig', function (httpService, appConfig) {
    this.getPosts = function () {
      return httpService.get(appConfig.dashboardServiceUrl + 'api/posts.json').then(data => data.data);
    }
  }]);
